import {poll} from '@yourcoach/async-utils';

import type {Expand} from '../types';

import {envManager} from '../../utils/env';
import {subtenantExpandCommon} from '../subtenant';
import {extendExpand} from '../utils/expand';

export const userExpandCommon: Expand = {
  user: [
    'avatar_id',
    'coach_logo_id',
    'coach_video_id',
    ['subtenant_id', null, subtenantExpandCommon],
    ['coach_subtenant_ids', null, subtenantExpandCommon],
  ],
};

poll(
  () => envManager.isReady,
  () => {
    if (envManager.isB2b) {
      extendExpand(userExpandCommon, ['population_ids'], true);
    }
  },
);
